import React, { Fragment } from 'react';
import { Breadcrumbs } from '../../../AbstractElements';
import { ProductListDesc, ProductListTitle } from '../../../Constant';
import BillingTableData from './BillingTableData';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import HeaderCard from '../../Common/Component/HeaderCard';


const BillingList = () => {
    return (
        <Fragment>
            <Breadcrumbs parent="Dashboard" title="Billing List" mainTitle="Billing List" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <HeaderCard title={"Patient Payment Details"} span1={"invoice"} />
                            <CardBody>
                                <BillingTableData />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};
export default BillingList;